
import { Component, Vue } from "vue-property-decorator";

import task_routes from "@/api/routes/tasks";
import skill_routes from "@/api/routes/skills";

import TaskTask, { taskIndividualTabs } from "@/models/task/task";

import CTaskChangeSettings from "./TaskChangeSettings.vue";
import CTaskChangeMaterials from "./TaskChangeMaterials.vue";
import TaskSkillBlock from "@/models/task/skillBlock";
import SkillCategory, { ESkillCategory } from "@/models/skill/category";

export interface ITaskIndividualCreate {
  user_id: string;
  task_id: null;
}

@Component({
  name: "CTaskCreateIndividual",
  components: {
    CTaskChangeSettings,
    CTaskChangeMaterials
  }
})
export default class CTaskCreateIndividual extends Vue {
  public task: ITaskIndividualCreate | null = null;

  public new_task: TaskTask = new TaskTask();
  public skills: TaskSkillBlock[] = [];
  public skill_categories: SkillCategory[] = [];

  public task_tabs = taskIndividualTabs;
  public current_tab_idx: number = 0;

  private watchers: Function[] = [];

  protected beforeDestroy() {
    this.watchers.forEach(unwatch => {
      unwatch();
    });
  }

  protected async created() {
    await this.loadSkillCategories();

    this.watchers.push(
      this.$store.watch(
        state => state.creatingIndividualTask,
        async (creatingIndividualTask: ITaskIndividualCreate | null) => {
          if (creatingIndividualTask) {
            await this.loadSkills(creatingIndividualTask.user_id);
          }

          this.task = creatingIndividualTask;

          if (this.task) {
            this.current_tab_idx = 0;
            this.new_task = new TaskTask();
            this.new_task.user_id = this.task.user_id;

            this.showModal();
          }
        }
      )
    );
  }

  private async loadSkills(user_id: string) {
    return this.$api
      .get(task_routes.user_skills, { params: { user_id } })
      .then(({ data: res }: { data: TaskSkillBlock[] }) => {
        this.skills = res;
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  private async loadSkillCategories() {
    return this.$api
      .get(skill_routes.categories, {
        params: { exclude_id: ESkillCategory.LEADERSHIP_ID }
      })
      .then(({ data: res }: { data: SkillCategory[] }) => {
        this.skill_categories = res;
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  public async createTask() {
    return await this.$api
      .post(task_routes.tasks, this.new_task)
      .then(({ data: res }: { data: TaskTask }) => {
        this.$store.commit("createdIndividualTask", res);

        this.$notify({
          group: "notifications",
          type: "success",
          text: "Задание создано",
          speed: 500
        });

        this.hideModal();
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  public showModal() {
    this.$modal.show("create_task_modal");
  }

  public hideModal() {
    this.$modal.hide("create_task_modal");
    this.$store.commit("creatingIndividualTask", null);
  }

  public allowWrite() {
    return this.$api.allowWrite();
  }
}
